import type { MobilityAd } from "@mobility-item-page/types";
import { isPrivateAdvertiser } from "./typeguards.ts";

export enum EventType {
  View = "View",
  Click = "Click",
  UIElement = "UIElement",
  ClassifiedAd = "ClassifiedAd",
}

export enum ObjectPosition {
  Map = "Map",
  AboveMap = "Above map",
  BelowGallery = "Below gallery",
}

export enum ElementType {
  Button = "Button",
  Link = "Link",
  Map = "Map",
  Tab = "Tab",
  Image = "Image",
  EmailIcon = "Email icon",
  CopyLink = "Copy link",
  FacebookIcon = "Facebook icon",
  PhoneNumber = "Phone number",
  TwitterIcon = "Twitter icon",
  Video = "Video",
}

export enum Intent {
  Call = "Call",
  Cancel = "Cancel",
  Click = "Click",
  Create = "Create",
  Dismiss = "Dismiss",
  Edit = "Edit",
  Like = "Like",
  Login = "Login",
  Minimize = "Minimize",
  Open = "Open",
  Report = "Report",
  Send = "Send",
  Share = "Share",
  Show = "Show",
  Sort = "Sort",
  Unlike = "Unlike",
  View = "View",
  Watch = "Watch",
}

export enum TargetType {
  Article = "Article",
  ClassifiedAd = "ClassifiedAd",
  ExternalContent = "ExternalContent",
  Form = "Form",
  Listing = "Listing",
  Page = "Page",
  Message = "Message",
}

export const getListingType = (ownerUrn: string): string => {
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);
  return isPrivateAd ? "private" : "professional";
};

export const getSubVerticalForMobilityAd = (adViewType?: MobilityAd["adViewType"]): string | undefined => {
  switch (adViewType) {
    case "car-new":
    case "car-used":
    case "car-used-business":
    case "car-leasing":
    case "car-leasing-business":
    case "caravan":
    case "mobile-home":
      return "car";
    case "agriculture-tractor":
    case "agriculture-thresher":
    case "agriculture-tools":
    case "truck":
    case "construction":
    case "bus":
      return "b2b";
    case "boat-new-sale":
    case "boat-sale":
    case "boat-wanted":
    case "boat-rent":
    case "boat-motor":
      return "boat";
    case "atv":
    case "motorcycle":
    case "moped":
    case "snowmobile":
      return "mc";
    default:
      return undefined;
  }
};
